import React from "react";
import { Checkbox } from "antd";
import styled from "@emotion/styled";
import { CheckboxChangeEvent } from "antd/lib/checkbox";

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
}) => {
  const handleChange = (e: CheckboxChangeEvent) => {
    onChange(e.target.checked);
  };

  return <StyledCheckbox checked={checked} onChange={handleChange} />;
};

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  "&.ant-checkbox-wrapper": {
    fontSize: "1.4rem",
    width: "2.4rem",
  },

  ".ant-checkbox-inner": {
    width: "2.4rem",
    height: "2.4rem",

    "&::after": {
      left: "32%",
    },
  },

  ".ant-checkbox-checked .ant-checkbox-inner": {
    backgroundColor: theme.color.black,
    borderColor: theme.color.black,
  },

  ".ant-checkbox-checked::after": {
    border: `2px solid ${theme.color.black}`,
  },
}));

export default CustomCheckbox;
